import { createContext, useMemo } from 'react';

import { Logger, type LoggerConfig } from '../../logger';

interface LoggerContextValue {
  logger: Logger;
}

const LoggerContext = createContext<LoggerContextValue | null>(null);

export interface LogProviderProps {
  config?: LoggerConfig;
  children: React.ReactNode;
}

function LoggerProvider(props: Readonly<LogProviderProps>) {
  const { config, children } = props;

  const baseLogger = useMemo(() => new Logger(config), []);

  const contextValue = useMemo(
    () => ({
      logger: baseLogger,
    }),
    [baseLogger],
  );

  return <LoggerContext.Provider value={contextValue}>{children}</LoggerContext.Provider>;
}

export { LoggerContext, LoggerProvider };
